/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import CommentsThreadDescriptor, { IThread, IThreadJSON } from '../descriptors/commentsthreaddescriptor';

export interface IAddCommentMessage extends IMessage {
	commentThreadId: string;
	content: string;
	documentId: string;
	commentId: string;
	createdAt: string;
	userId: string;
	attributes: string;
	commentThread?: IThreadJSON;
}

export default class AddCommentMessage extends Message {
	public readonly createdAt: Date | string;

	public static readonly TYPE: string = '91';

	public static readonly READABLE_TYPE_NAME: string = 'addComment';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2AddCommentMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			content: {
				type: 'string',
				id: 2
			},
			documentId: {
				type: 'string',
				id: 3
			},
			commentId: {
				type: 'string',
				id: 4
			},
			createdAt: {
				type: 'string',
				id: 5
			},
			userId: {
				type: 'string',
				id: 6
			},
			attributes: {
				type: 'string',
				id: 7
			},
			commentThread: {
				type: 'CommentsThreadDescriptor',
				id: 8
			}
		}
	};

	public constructor(
		public readonly documentId: string,
		public readonly commentThreadId: string,
		public readonly content: string,
		public readonly commentId: string = '',
		createdAt?: string | Date,
		public readonly userId: string = '',
		public readonly attributes: Record<string, unknown> | null = null,
		public readonly commentThread?: IThread
	) {
		super();

		this.createdAt = createdAt ? new Date( createdAt ) : '';
	}

	public toJSON(): IAddCommentMessage {
		return {
			commentThreadId: this.commentThreadId,
			content: this.content,
			documentId: this.documentId,
			commentId: this.commentId,
			// instanceof operator can be safely used on node constructors e.g Date
			// eslint-disable-next-line no-restricted-syntax
			createdAt: this.createdAt instanceof Date ? this.createdAt.toISOString() : this.createdAt,
			userId: this.userId,
			attributes: JSON.stringify( this.attributes ),
			commentThread: this.commentThread ? CommentsThreadDescriptor.toJSON( this.commentThread ) : undefined
		};
	}

	public static fromJSON( object: IAddCommentMessage ): AddCommentMessage {
		return new AddCommentMessage(
			object.documentId,
			object.commentThreadId,
			object.content,
			object.commentId ? object.commentId : undefined,
			object.createdAt ? new Date( object.createdAt ) : undefined,
			object.userId ? object.userId : undefined,
			object.attributes ? JSON.parse( object.attributes ) : {},
			object.commentThread ? CommentsThreadDescriptor.fromJSON( object.commentThread ) : undefined
		);
	}
}
